import GetTypographyStyles from './GetTypographyStyles';

export {
  GetTypographyStyles
};

export default GetTypographyStyles;